import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { Supplier } from 'depoto-core/src/entities'
import { HistoryUtil, SchemaUtil } from '../../utils'
import { CoreService, NotificationService } from '../../services'
import { AbstractControl, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms'
import { CheckDataChanges } from '../../services/can-deactivate-guard.service'
import * as Sentry from '@sentry/angular-ivy'
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'app-supplier',
  templateUrl: 'supplier.component.html',
})
export class SupplierComponent implements OnInit, CheckDataChanges {
  supplier: Supplier
  isCreating = false
  loading = true
  submitted = false

  supplierForm = new UntypedFormGroup({
    name: new UntypedFormControl({ value: '', disabled: false }, [Validators.required]),
  })

  constructor(
    private route: ActivatedRoute,
    public router: Router,
    private notificationService: NotificationService,
    private translateService: TranslateService,
    private core: CoreService,
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false
  }

  ngOnInit() {
    const id = this.route.snapshot.params['id']
    if (isNaN(id)) {
      this.isCreating = true
      this.supplier = new Supplier()
      this.loading = false
    } else {
      this.refreshData(id)
    }
  }

  public fillFormValues() {
    this.supplierForm.setValue({ name: this.supplier.name })
  }

  public getFormValues() {
    this.supplier.name = this.supplierForm.value.name
  }

  hasUnsavedDataChanges(): boolean {
    return false
  }

  async refreshData(id: number) {
    this.loading = true
    const supplier = await this.core.services.supplier.getById(id, SchemaUtil.supplier)
    this.loading = false
    if (supplier) {
      this.supplier = new Supplier(supplier)
      this.fillFormValues()
    }
  }

  navigateBack() {
    if (window.history.length > 1) {
      window.history.back()
    } else {
      this.router.navigate(['/suppliers'])
    }
  }

  async createSupplier() {
    this.submitted = true
    if (this.supplierForm.invalid) {
      return
    }
    this.loading = true
    try {
      this.getFormValues()
      this.supplier = await this.core.services.supplier.create(this.supplier, SchemaUtil.supplier)
      this.notificationService.success(this.translateService.instant('alert.supplier.created'))
      this.isCreating = false
    } catch (e) {
      console.log(e)
    } finally {
      this.submitted = false
      this.loading = false
    }
  }

  async updateSupplier() {
    this.submitted = true
    if (this.supplierForm.invalid) {
      return
    }
    this.loading = true
    try {
      this.getFormValues()
      this.supplier = await this.core.services.supplier.update(this.supplier)
      this.notificationService.success(this.translateService.instant('alert.supplier.updated'))
    } catch (err) {
      console.log(err)
    } finally {
      this.submitted = false
      this.loading = false
    }
  }

  async deleteSupplier() {
    const confirmation = confirm(
      this.translateService.instant('suplier.delete.confirmation', { name: this.supplier.name }),
    )
    if (confirmation) {
      try {
        await this.core.services.supplier.delete(this.supplier)
        this.notificationService.success(this.translateService.instant('alert.supplier.deleted'))
        this.navigateBack()
      } catch (err) {
        console.log(err)
      }
    }
  }

  get formControls(): { [key: string]: AbstractControl } {
    return this.supplierForm.controls
  }
}
